import { axiosInstance, axiosInstanceNotAuthorized } from './axiosInstance';

export const getLanguages = () => axiosInstanceNotAuthorized.get(`languages`);

export const updateLanguage = (language) => axiosInstance.put('user/update_language/', { language });
